import { useState } from 'react'
import { useSelector } from 'react-redux';
import { faBasketball, faBookOpen, faBug, faCalendar, faCircleQuestion, faChartLine, faChessKnight, faClipboardList, faClipboardUser, faFileSignature, faHandshake, faListOl, faMedal, faNewspaper, faPeopleGroup, faRankingStar, faRightLeft, faScrewdriverWrench, faSitemap, faStar, faTrophy, faUserPlus, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppShell from '@/components/SHARED/app-shell/app-shell.component';
import BugModal from '@/components/layout-auth/bug-modal/bug-modal.component';

// The manager side's page frame. With a leagueId the menu shows that
// league's pages; without one (league list, join page) only the general
// entries.
// showPortal adds the Transfer portal entry (college offseason);
// showRecruiting the Recruiting page (college);
// showOffice the Front office (pro: contracts and free agents), Trades and
// Draft.
// College gets Conference tournaments and National tournament pages where
// pro has Playoffs.
// themeVars: the team's colors over the theme (college).
const ManagerShell = ({ leagueId, title, rankingsLabel = 'Rankings', theme, themeVars, showPortal, showRecruiting, showOffice, children }) => {

    const profile = useSelector(state => state.userData.userProfile);
    const [ showBugModal, setShowBugModal ] = useState(false);

    const base = `/home/${leagueId}`;
    const items = [
        ...(leagueId ? [
            { to: base, label: 'My Team', icon: faPeopleGroup, end: true },
            { to: `${base}/roster`, label: 'Roster', icon: faClipboardUser },
            { to: `${base}/lineup`, label: 'Lineup', icon: faClipboardList },
            { to: `${base}/strategy`, label: 'Strategy', icon: faChessKnight },
            ...(showRecruiting ? [{ to: `${base}/recruiting`, label: 'Recruiting', icon: faStar }] : []),
            ...(showPortal ? [{ to: `${base}/portal`, label: 'Transfer portal', icon: faRightLeft }] : []),
            ...(showOffice ? [
                { to: `${base}/office`, label: 'Front office', icon: faFileSignature },
                { to: `${base}/trades`, label: 'Trades', icon: faHandshake },
                { to: `${base}/draft`, label: 'Draft', icon: faUserPlus },
            ] : []),
            { to: `${base}/news`, label: 'News', icon: faNewspaper },
            { to: `${base}/schedule`, label: 'Schedule', icon: faCalendar },
            { to: `${base}/standings`, label: 'Standings', icon: faListOl },
            { to: `${base}/leaders`, label: 'Leaders', icon: faChartLine },
            { to: `${base}/managers`, label: 'Managers', icon: faUsers },
            { to: `${base}/rankings`, label: rankingsLabel, icon: faRankingStar },
            { to: `${base}/postseason`, label: showOffice ? 'Playoffs' : 'Conference tournaments', icon: faTrophy },
            ...(showOffice ? [] : [{ to: `${base}/national`, label: 'National tournament', icon: faBasketball }]),
            { to: `${base}/history`, label: 'History', icon: faBookOpen },
            { to: `${base}/records`, label: 'Record book', icon: faMedal },
        ] : []),
        { to: '/leagues', label: 'Leagues', icon: faSitemap },
        { to: '/how-it-works', label: 'How it works', icon: faCircleQuestion },
        ...(profile?.admin ? [{ to: '/admin', label: 'Admin', icon: faScrewdriverWrench }] : []),
    ];

    // The phone tab bar's shortcuts (between Back and Menu).
    const tabs = leagueId ? items.filter(i => [base, `${base}/lineup`, `${base}/schedule`].includes(i.to)) : undefined;

    return (
        <AppShell
            title={title}
            items={items}
            tabs={tabs}
            logoTo='/leagues'
            titleTo={leagueId ? base : undefined}
            theme={theme}
            themeVars={themeVars}
            menuExtra={(close) => (
                <>
                    <hr className='app-menu-divider' />
                    <button className='app-menu-item' onClick={() => { close(); setShowBugModal(true); }}>
                        <FontAwesomeIcon className='app-menu-icon' icon={faBug} size='lg' />
                        Report a bug
                    </button>
                </>
            )}>
            {children}
            <BugModal show={showBugModal} cancel={() => setShowBugModal(false)} />
        </AppShell>
    )
}

export default ManagerShell
